import type { IconSvgProps } from '../Icon.types';

export const DotFilled = ({ width, height }: IconSvgProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 2 2">
      <circle cx="1" cy="1" r="1" />
    </svg>
  );
};
